<div class="question text">{replaceText($host.question, $host.players)}...</div>

<style>
.question {    
    border-radius: 50px;
    padding: 0.8em;
    color: #fff;
    font-size: 2em;
    line-height: 1.3em;
    text-align: center;
    max-width: 70%;
    margin: 0px auto;
    background: linear-gradient(170deg, var(--kilo), var(--mega));
    box-shadow:  30px 30px 59px #d3801a, 
             -30px -30px 59px #ffad23;
}
</style>

<script>
import ProfileIcon from "../../../components/player/Icon.svelte"
import Card from "../../../components/cards/Card.svelte"

import { host } from "../../../stores/"

import { replaceText } from "../../../code/replaceText"
</script>